import {
  Flex,
  Label1,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '@sainsburys-tech/fable'
import { AlertCircleFilled, Close, Tick } from '@sainsburys-tech/icons'
import React from 'react'

import AppTooltip from '../../../common/components/Tooltip/AppTooltip'
import { IBatchItem } from '../../types/IBatchItem'
import Incrementor from './Incrementor'

interface IProps {
  batchItems: IBatchItem[]
  isInvalid: boolean
  onChange: (e: any, f: any) => void
}

const BatchRow = React.memo(
  ({
    bi,
    onChange,
  }: {
    bi: IBatchItem
    onChange: (skuId: number, value: number) => void
  }) => {
    return (
      <TableRow
        className={`${bi.quantityProduced !== 0 ? 'c-batch-table-in-batch-edge' : ''}`}
        key={bi.skuId}
      >
        <TableCell className='c-batch-table-in-batch-column'>
          {bi.quantityProduced !== 0 ? (
            <Tick
              style={{
                width: '20px',
                height: '20px',
                display: 'block',
                color: 'var(--fable-color-icon-success-strong, #11642a)',
              }}
            />
          ) : (
            <Close
              style={{
                width: '20px',
                height: '20px',
                display: 'block',
                color: 'var(--fable-color-icon-error-strong, #b3261e)',
              }}
            />
          )}
        </TableCell>
        <TableCell className='c-batch-table-desktop'>{bi.skuName}</TableCell>
        <TableCell className='c-batch-table-mobile-sku'>
          <div className='c-batch-table-mobile'>{bi.skuName}</div>
          <Incrementor
            id={bi.skuId}
            step={1}
            value={bi.quantityProduced}
            setValue={onChange}
          />
        </TableCell>
      </TableRow>
    )
  },
  (prev, next) => prev.bi.quantityProduced === next.bi.quantityProduced,
)

const BatchTable = (props: IProps) => (
  <Table testid='batch-table' className='c-batch-table' layout={'auto'}>
    <TableHeader className='c-batch-table-desktop'>
      <TableRow>
        <TableCell>
          {props.isInvalid && (
            <AlertCircleFilled className='c-form-alert-icon-red' />
          )}
          <Label1>In batch</Label1>
        </TableCell>
        <TableCell>
          <Label1>Product</Label1>
        </TableCell>
        <TableCell>
          <Flex direction='row' alignItems='center' gap='sm'>
            <Label1>Portion(s)</Label1>
            <AppTooltip
              value={"Quantity of portions you're cooking per product"}
            />
          </Flex>
        </TableCell>
      </TableRow>
    </TableHeader>
    <TableBody>
      {props.batchItems.map((bi: IBatchItem) => (
        <BatchRow
          key={bi.skuId}
          bi={bi}
          onChange={(skuId, value) => props.onChange(skuId, value)}
        />
      ))}
    </TableBody>
  </Table>
)

export default BatchTable
